import type * as Types from '../../../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTimeEfficiencyQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetTimeEfficiencyQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly timeEfficiency: { readonly __typename?: 'EfficiencyTimeData', readonly time: number, readonly cost: number } } | null } | null };

export type GetStatsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetStatsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly graphStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly currency: string }> } | null } | null };


export const GetTimeEfficiencyDocument = gql`
    query GetTimeEfficiency($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      timeEfficiency(startDate: $startDate, endDate: $endDate) {
        time
        cost
      }
    }
  }
}
    `;

/**
 * __useGetTimeEfficiencyQuery__
 *
 * To run a query within a React component, call `useGetTimeEfficiencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeEfficiencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeEfficiencyQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTimeEfficiencyQuery(baseOptions: Apollo.QueryHookOptions<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables> & ({ variables: GetTimeEfficiencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables>(GetTimeEfficiencyDocument, options);
      }
export function useGetTimeEfficiencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables>(GetTimeEfficiencyDocument, options);
        }
export function useGetTimeEfficiencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables>(GetTimeEfficiencyDocument, options);
        }
export type GetTimeEfficiencyQueryHookResult = ReturnType<typeof useGetTimeEfficiencyQuery>;
export type GetTimeEfficiencyLazyQueryHookResult = ReturnType<typeof useGetTimeEfficiencyLazyQuery>;
export type GetTimeEfficiencySuspenseQueryHookResult = ReturnType<typeof useGetTimeEfficiencySuspenseQuery>;
export type GetTimeEfficiencyQueryResult = Apollo.QueryResult<GetTimeEfficiencyQueryPage, GetTimeEfficiencyQueryVariables>;
export const GetStatsDocument = gql`
    query GetStats($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      graphStats(startDate: $startDate, endDate: $endDate) {
        currency
      }
    }
  }
}
    `;

/**
 * __useGetStatsQuery__
 *
 * To run a query within a React component, call `useGetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetStatsQuery(baseOptions: Apollo.QueryHookOptions<GetStatsQueryPage, GetStatsQueryVariables> & ({ variables: GetStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsQueryPage, GetStatsQueryVariables>(GetStatsDocument, options);
      }
export function useGetStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsQueryPage, GetStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsQueryPage, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export function useGetStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatsQueryPage, GetStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatsQueryPage, GetStatsQueryVariables>(GetStatsDocument, options);
        }
export type GetStatsQueryHookResult = ReturnType<typeof useGetStatsQuery>;
export type GetStatsLazyQueryHookResult = ReturnType<typeof useGetStatsLazyQuery>;
export type GetStatsSuspenseQueryHookResult = ReturnType<typeof useGetStatsSuspenseQuery>;
export type GetStatsQueryResult = Apollo.QueryResult<GetStatsQueryPage, GetStatsQueryVariables>;